import { create } from "zustand";

interface EventHighlightStore {
  highlightedEventId: string | null;
  setHighlightedEventId: (id: string | null) => void;
}

export const useEventHighlightStore = create<EventHighlightStore>((set) => ({
  highlightedEventId: null,
  setHighlightedEventId: (id) => set({ highlightedEventId: id }),
}));

// Selector hook for individual components - only re-renders when highlight status changes for this specific event
export const useIsEventHighlighted = (eventId: string) =>
  useEventHighlightStore((state) => state.highlightedEventId === eventId);

// Action hook for setting highlight - doesn't cause re-renders
export const useEventHighlightActions = () => ({
  setHighlightedEventId:
    useEventHighlightStore.getState().setHighlightedEventId,
});
